import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { getAuthToken } from '../../auth/context/AuthContext';

const API = `${process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api'}/platform`;

export default function SuperAdmins() {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoad]  = useState(true);
  const [err, setErr]       = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/super-admins`, {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        });
        if (!res.ok) {
          const d = await res.json().catch(() => ({}));
          throw new Error(d.detail || `Failed to load super admins (${res.status})`);
        }
        const data = await res.json();
        setAdmins(data.super_admins || []);
      } catch (e) { setErr(e.message); }
      setLoad(false);
    })();
  }, []);

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Super Admins</div>
          <div className="page-subtitle">
            Platform owners — they belong to no company and can see every customer
          </div>
        </div>
      </div>

      {err && <div className="alert alert-error" style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6 }}><AlertTriangle size={14} strokeWidth={2} /> {err}</div>}

      {loading ? (
        <div className="empty-state"><div className="empty-state-text">Loading…</div></div>
      ) : (
        <>
          <div className="card" style={{ overflowX: 'auto', marginBottom: 16 }}>
            <table className="table" style={{ width: '100%' }}>
              <thead>
                <tr><th>Name</th><th>Email</th><th>Sign-in</th><th>Status</th></tr>
              </thead>
              <tbody>
                {admins.map(a => (
                  <tr key={a.id}>
                    <td style={{ fontWeight: 600 }}>
                      {a.name}
                      {a.is_you && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}> (you)</span>}
                    </td>
                    <td style={{ color: 'var(--text-muted)' }}>{a.email}</td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                      {a.has_password ? 'Password' : <span style={{ color: 'var(--red)' }}>cannot sign in</span>}
                    </td>
                    <td>
                      <span style={{
                        color: a.is_active ? 'var(--green)' : 'var(--text-muted)',
                        fontSize: 12, fontWeight: 600,
                      }}>
                        {a.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
